<template>
	<div class="form-select">
		<label :for="_uid" >{{title}}</label>
		<div :class='{focus: focussed, "input-block": true}'>
			<select
				:id="_uid"
				:class='{ disabled }'
				ref="item"
				:value="value"
				:name="name"
				:autocomplete="autocomplete"
				@input="update()"
				@focus="onFocus()"
				@blur="offFocus()"
				@change="$emit('change', $event)"
				:disabled="disabled">
				<option value='' v-if='default_text !== null' :disabled="default_disabled">{{default_text}}</option>
				<option v-for="option in options" :class="[option_class, option.id]" :value='option.id'>{{option.value}}</option>
			</select>
		</div>
	</div>
</template>

<script>

export default {
	name: "FormSelect",
	props: {
		value: {
			default: ""
		},
		required: {
			default: false
		},
		option_class: {
			default: ""
		},
		options: {
			default: function(){
				return new Array({ value: "", id: 0 });
			},
			required: true
		},
		default_text: {
			default: "Select One"
		},
		default_disabled: {
			default: false
		},
		title: {
			default: ""
		},
		name: {
			default: "select"
		},
		autocomplete: {
			default: ""
		},
		disabled: {
			default: false
		},
		hint: {
			default: ""
		}
	},
	data(){
		return {
			focussed: false
		};
	},
	computed: {
		selected_value(){
			var selection = this.options.filter(option => option.id == this.value);
			if(selection.length > 0) return selection[0];
			else return { value: this.default_text, id: 0 };
		}
	},
	methods: {
		onFocus(){
			this.focussed = true;
		},
		offFocus(){
			this.focussed = false;
		},
		update() {
			this.$emit('input', this.$refs.item.value);
		}
	}
};
</script>

<style scoped lang="scss">
	.input-block{
		position: relative;
		display: flex;
		align-items: center;
		color: #919eab;
		cursor: text;
		border: 1px solid #CDCDCD;
		border-radius: 7px;
	}
	label{
		width: 100%;
		margin-bottom: 5px;
		font-family: 'proximanova-bold';
		font-size: 18px;
	}
	select{
		position: relative;
		z-index: 20;
		display: block;
		flex: 1 1 0%;
		width: 100%;
		margin: 0;
		padding: 8px 10px;
		background: none;
		border: 1px solid transparent;
		height: 42px;
	}
	select:focus{
		outline: 0px;
	}
	.disabled{
		background-color: #EBEBEB;
	}
</style>
